// @flow
import Component from './main'
export default () => ({
  path: 'action-queue',
  element: <Component />,
})
